/* eslint-disable camelcase */
import { FC } from 'react';
import { Text, Button, ButtonKind, Icon } from '@livechat/design-system-react-components';

import { getLogoSource } from 'helpers/logo';
import { getProductDisplayName } from 'helpers/product';

import { useJoinOrganizationAndProduct } from './use-join-organization-and-product';

import * as styles from './styles';

type Props = {
  onJoinBlocked(organizationId: string): void;
  organizationId: string;
  product: string;
  kind?: ButtonKind;
  hideIcon?: boolean;
};

export const JoinProductButton: FC<Props> = ({
  onJoinBlocked,
  organizationId,
  product,
  kind = 'secondary',
  hideIcon = false,
}) => {
  const { handleJoinProduct, isLoading } = useJoinOrganizationAndProduct({
    organization_id: organizationId,
    product,
    onJoinBlocked,
  });

  return (
    <div>
      <Button
        data-testid={`join-product-button-${product.toLowerCase()}`}
        kind={kind}
        css={styles.goToProductButton(kind)}
        onClick={handleJoinProduct}
        loading={isLoading}
      >
        {!hideIcon && <Icon source={getLogoSource(product)} />}
        <Text bold css={styles.goToProductButtonText(!hideIcon)}>
          Join {getProductDisplayName(product, true)}
        </Text>
      </Button>
    </div>
  );
};
